<div class="mat-elevation-z4 section-container">
    <div class="title-bar">
        <div class="title-bar__right">
            <form class="billing-form" [formGroup]="form">
                <mat-form-field>
                    <mat-label>Hónap kiválasztása</mat-label>
                    <input matInput formControlName="month" [matDatepicker]="dp" />
                    <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
                    <mat-datepicker #dp startView="multi-year" (monthSelected)="setMonthAndYear($event, dp)"
                        panelClass="example-month-picker">
                    </mat-datepicker>
                </mat-form-field>
                <button mat-raised-button class="form-button" color="primary" (click)="getBillingReport()" [disabled]="!form.valid">
                    RIPORT
                </button>
                <button mat-raised-button class="form-button" color="primary" (click)="getPaymentRequests()" [disabled]="!form.valid">
                    FIZETÉSI KÉRELMEK (CSV)
                </button>
            </form>
        </div>
    </div>
    <div class="sum">
        SZUMMA: {{ sum }}
    </div>

    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort>
            <ng-container matColumnDef="creationDateTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Létrehozás dátuma</th>
                <td mat-cell *matCellDef="let row">{{row.creationDateTime | date: 'yyyy.MM.dd. HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Típus</th>
                <td mat-cell *matCellDef="let row">
                    <span *ngIf="row.type === 'PAYMENT_REQUEST_UNATTENDED';">Fizető fél részvétele nélkül</span>
                    <span *ngIf="row.type === 'PAYMENT_REQUEST_PAYER_ATTENDED';">Fizető fél részvételével</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="payer">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Fizető fél</th>
                <td mat-cell *matCellDef="let row">{{row.payerName}}
                </td>
            </ng-container>

            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Összeg</th>
                <td mat-cell *matCellDef="let row">{{row.amount}}
                </td>
            </ng-container>

            <ng-container matColumnDef="comment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Közlemény</th>
                <td mat-cell *matCellDef="let row">{{row.comment}}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Státusz</th>
                <td mat-cell *matCellDef="let row">{{row.status}}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        @if (isLoading) {
        <progress-spinner></progress-spinner>
        }
    </div>

    <mat-paginator showFirstLastButtons [pageSizeOptions]="[5, 10, 20]" [pageSize]="20"
        aria-label="Select page of payment requests"></mat-paginator>
</div>
